// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___12X0Q","checked-wrapper":"styles__checked-wrapper___2iwQ8"};